module.exports = __webpack_public_path__ + "p1_img3.jpg?e7323731cb196d71ca70a06d1a08eb2b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img3.jpg
// module id = 105
// module chunks = 0